module.exports = __webpack_public_path__ + "img/20200227162442360截图20200227161723663.4d3ddcaa.jpg";